/**
 * link-box-block js
 */

 var component_link_box = function(args) {

  let links = (args.links);

  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener("mouseover", function() {

      let background = document.querySelector('#icon-box-background-' + i);
      // console.log(background);
      background.style.opacity = '1';

    });

    links[i].addEventListener("mouseleave", function() {

      let background = document.querySelector('#icon-box-background-' + i);
      // console.log(background);
      background.style.opacity = '0';

    });
  }

  /*
  // This handler will be executed every time the cursor
  // is moved over a different list item
  link.addEventListener("mouseover", function( event ) {


    console.log(link);

    // highlight the mouseover target
    event.target.style.color = "orange";

    // reset the color after a short delay
    setTimeout(function() {
      event.target.style.color = "";
    }, 500);
  }, false);
*/

  /*
  var header = document.querySelector('.site-header')

  if (header.classList.contains('scrolled-past-hero')) {
    header.classList.remove('scrolled-past-hero');
  } else {
    header.classList.add('scrolled-past-hero');
  }
    */


  // make the call chainable
  return this;


};
